import { HereMapsService } from '../..';
import StopInfoContent from './StopInfoContent';
import { behaviourGlyphTag, displayBehaviourTags, isCompositeBehaviour } from '../../../../types/stopBehaviour.type';

const { H } = HereMapsService;

export default (stop, position, type, t) => {
  const { sequence, place, timeSlot } = stop;
  const infoBubble = new H.ui.InfoBubble(position, {
    content: StopInfoContent({
      sequence,
      timeSlot,
      position,
      place,
      type,
      // The chips shown to the user: OPERATIONAL is dropped as the unspoken default so the bubble
      // agrees with the timeline (displayBehaviourTags). Empty for an untagged stop, so the rendered
      // bubble stays byte-identical.
      behaviourTags: displayBehaviourTags(stop),
      // The glyph's composite ring still tracks the full recognised set (isCompositeBehaviour), so a
      // {OPERATIONAL, SERVICE} stop keeps the ring that the map marker draws for it.
      composite: isCompositeBehaviour(stop),
      behaviourGlyphTag: behaviourGlyphTag(stop),
    }, t),
  });
  infoBubble.addClass('trip-info-infobubble');
  infoBubble.addClass('above-circle-infobubble');
  infoBubble.close();
  return infoBubble;
};
